import { FC, PropsWithChildren, ReactNode } from 'react'
import styles from './BestBadge.module.css'
import { BasicStyledComponent } from 'shared-definitions/types'
import clsx from 'clsx'

interface BestBadgeProps extends BasicStyledComponent {
  title: string
  iconEl: ReactNode
  featured: boolean
}

const BestBadge: FC<BestBadgeProps & PropsWithChildren> = ({
  featured,
  iconEl,
  title,
  className,
}) => (
  <div
    className={clsx(styles.container, className, {
      [styles.featured]: featured,
      [styles.default]: !featured,
    })}
  >
    {iconEl}
    {title}
  </div>
)

export default BestBadge
